import React from 'react';
import {createContext} from 'react';
import {useReducer} from 'react';

const INTIAL_VALUE = {
    type: 'CLOSE',
    texto: ''
};

const MessageContext = createContext();

export const MessageProvider = ({children}) => {

    const [state, dispacher] = useReducer((state,action) => {
        const msg = {
            open: true,
            texto: action.texto,
        };
        switch (action.type) {
            case 'AVISO':
                return {...msg, severity: 'success', time:2000 };
            case 'ERRO':
                return {...msg, severity: 'error' };
            case 'INFO':
                return {...msg, severity: 'info',time: 1500 };
            default:
                return INTIAL_VALUE;
        }
    },INTIAL_VALUE);

    const msgAviso = texto => dispacher({type: 'AVISO', texto});
    const msgErro = texto => dispacher({type: 'ERRO', texto});
    const msgInfo = texto => dispacher({type: 'INFO', texto});
    const msgClose = texto => dispacher({type: 'CLOSE', texto});

    return (
        <MessageContext.Provider value={{
            msgAviso,
            msgErro,
            msgInfo,
            msgClose,
            state
        }}>
            {children}
        </MessageContext.Provider>
    );
};

export default MessageContext;
